import { Quotes } from "phosphor-react"
import { AppText } from "~/ui/app-text"

interface Props {
  quoteText: string | null | undefined
  quoteAuthor: string | null | undefined
}

export const MessageAttachmentQuote: React.FC<Props> = ({ quoteText, quoteAuthor }) => {
  if (!quoteText) return null

  return (
    <div
      className="flex w-full min-w-[260px] max-w-[360px] flex-col gap-3 rounded-lg p-4"
      style={{ background: "linear-gradient(135deg, #8400FF 0%, #0077FF 100%)" }}
    >
      <div className="flex min-h-[24px] flex-row items-center gap-3">
        <Quotes size={20} weight="fill" className="text-base-white" />
        <AppText variant="hairline-1" className="text-base-white">
          {quoteAuthor || "Quote"}
        </AppText>
      </div>
      <AppText variant="body2-medium" className="text-base-white">
        {quoteText}
      </AppText>
    </div>
  )
}
